import { Modal } from 'components/common';
import React from 'react';
import { OmniHistoriesLeadManageProvider, TabChatManagementKeys, useOmniHistoriesLeadManageContext } from 'contexts';
import OmniChannelLeadChatHistoriesFilterForm from './OmniChannelLeadChatHistoriesFilterForm';
import OmniChannelLeadChatOngoingList from './OmniChannelLeadChatOngoingList';
import OmniChannelLeadChatHistoriesChatBox from './OmniChannelLeadChatHistoriesChatBox';
import { omniChatMessages } from 'messages';
import { ChatIcon, HistoryRotateIcon } from 'assets';
import { twMerge } from 'tailwind-merge';
import OmniChannelLeadChatHistoriesSessionList from './OmniChannelLeadChatHistoriesSessionList';
import { Spin } from 'antd';

type Props = {
  onCancel?: () => void;
  open?: boolean;
};

const OmniChannelChatHistoriesModal: React.FC<Props> = ({ open, onCancel }) => {
  const { chatSession, tab, setTab, isLoadingHistories, isLoadingOngoing } = useOmniHistoriesLeadManageContext();

  return (
    <Modal
      styles={{
        body: { padding: 0 }
      }}
      width={1336}
      open={open}
      onCancel={onCancel}
      centered
      maskClosable={false}
      destroyOnClose
      footer={null}
      title='Lịch sử chat'
    >
      <div className='relative flex h-[calc(100vh-260px)] overflow-hidden rounded-b-[10px]'>
        <div className='flex max-h-[calc(100vh-260px)] w-[400px] overflow-auto rounded-tl-[10px] bg-[#F5F3F6]'>
          <OmniChannelLeadChatHistoriesFilterForm />
        </div>
        <div className='h-ful relative flex max-h-full flex-1 overflow-hidden bg-white'>
          {/* Phiên chat */}
          {!chatSession && (
            <Spin className='w-full' spinning={isLoadingHistories || isLoadingOngoing}>
              <div className='flex h-[76px] items-center justify-center gap-2'>
                <div
                  onClick={() => setTab(TabChatManagementKeys.ONGOING)}
                  className={twMerge(
                    'flex h-9 cursor-pointer items-center gap-2 rounded-full border px-4',
                    tab === TabChatManagementKeys.ONGOING && 'bg-[#222A41] text-white'
                  )}
                >
                  <ChatIcon height={14} width={14} />
                  <span className='text-sm font-semibold'>{omniChatMessages.ongoing}</span>
                </div>

                <div
                  onClick={() => setTab(TabChatManagementKeys.HISTORY)}
                  className={twMerge(
                    'flex h-9 cursor-pointer items-center gap-2 rounded-full border px-4',
                    tab === TabChatManagementKeys.HISTORY && 'bg-[#222A41] text-white'
                  )}
                >
                  <HistoryRotateIcon height={14} width={14} />
                  <span className='text-sm font-semibold'>{omniChatMessages.historyChat}</span>
                </div>
              </div>
              {tab === TabChatManagementKeys.ONGOING && <OmniChannelLeadChatOngoingList />}
              {tab === TabChatManagementKeys.HISTORY && <OmniChannelLeadChatHistoriesSessionList />}
            </Spin>
          )}

          {/* Hộp chat */}
          {chatSession && <OmniChannelLeadChatHistoriesChatBox chatSession={chatSession} />}
        </div>
      </div>
    </Modal>
  );
};

const OmniChannelChatHistoriesModalContent = (props: Props) => {
  if (!props.open) return null;
  return (
    <OmniHistoriesLeadManageProvider>
      <OmniChannelChatHistoriesModal {...props} />
    </OmniHistoriesLeadManageProvider>
  );
};

export default OmniChannelChatHistoriesModalContent;
